export default __webpack_public_path__ + "static/media/aiims.b56b9d53.jpg";